import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudUpload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCloudUpload"><Path d="M9.5 19.5H7C3.96243 19.5 1.5 17.0376 1.5 14C1.5 11.3187 3.4187 9.08552 5.95801 8.59857C6.91321 6.19737 9.25838 4.5 12 4.5C15.4303 4.5 18.24 7.15724 18.483 10.5256C20.7411 10.7666 22.5 12.6779 22.5 15C22.5 17.4853 20.4853 19.5 18 19.5H14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 14.25L12 11.75L9.5 14.25" stroke="currentColor" strokeLinecap="square"/><Path d="M12 19.5V12.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCloudUpload;
